import styled from "styled-components";
import { theme } from "../theme";

export const StyledDecisionCardProperties = styled.div`
	margin: ${(props) => (props.basisDisplay ? "1.25rem 0" : "0.75rem 0")};
	margin-bottom: ${(props) => (props.keywordDisplay ? "0.5rem" : "1.25rem")};
	padding: 1rem 0;
	border-top: ${(props) => (props.basisDisplay ? "1px solid #f1f3f4" : "none")};
	border-bottom: ${(props) => (props.keywordDisplay ? "1px solid #f1f3f4" : "none")};

	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-wrap: wrap;
	row-gap: 1.25rem;

	& > *:first-child {
		width: 100%;
		min-height: 3.6rem;
		padding-left: 5.2rem;
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	& > *:not(:first-child) {
		width: 33.333%;
		min-width: 100px;
		
		@media (max-width: 900px) {
			width: 50%;
		}
		
		@media (max-width: 600px) {
			width: 100%;
		}
	}

	/* Special styling for date row */
	& .date-row {
		width: 100% !important;
		display: flex !important;
		gap: 0.5rem;
		padding: 0.75rem 0;
		align-items: stretch;
		
		@media (max-width: 700px) {
			flex-direction: column;
			gap: 1.25rem;
		}
		
		& > div {
			flex: 1;
			width: auto !important;
			min-width: 0; /* Allow shrinking */
			display: flex;
			flex-direction: column;
			gap: 0.375rem;
		}
		
		/* Decision Date column */
		& > div:first-child {
			flex: 0.8;
			min-width: 100px;
		}
		
		/* Validity Period column */
		& > div:last-child {
			flex: 1.2;
			min-width: 140px;
		}
		
		/* Ensure consistent label styling in date row */
		& > div > span {
			color: ${theme.color.gray} !important;
			font-size: 0.75rem !important;
			font-weight: 600 !important;
			font-family: ${theme.font.primary} !important; /* Changed to museo for headings */
			text-transform: uppercase !important;
			letter-spacing: 0.05em !important;
			margin-bottom: 0.375rem !important;
		}
	}

	& span {
		margin-bottom: 0;
		display: block;
		color: ${theme.color.gray};
		font-size: 0.75rem;
		font-weight: 600;
		font-family: ${theme.font.primary}; /* Changed to museo for headings */
		text-transform: uppercase;
		letter-spacing: 0.05em;
	}

	& p {
		font-size: 0.95rem !important;
		font-weight: 500 !important;
		color: ${theme.color.black} !important;
		margin: 0 !important;
		line-height: 1.5 !important;
		font-family: ${theme.font.secondary} !important;
	}

	& .decision-date,
	& .validity-status {
		font-size: 0.9rem !important;
		font-weight: 700 !important;
		color: ${theme.color.black} !important;
		font-family: ${theme.font.secondary} !important;
		line-height: 1.4 !important;
		margin: 0 !important;
		font-variant: small-caps !important;
		text-align: left !important;
	}

	& .decision-date {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-variant: small-caps !important;
		font-size: 0.9rem !important;
		font-weight: 700 !important;
		color: ${theme.color.black} !important;
		font-family: ${theme.font.secondary} !important;
		text-align: left;
		text-transform: lowercase !important;
	}

	& .validity-status {
		display: flex !important;
		align-items: center !important;
		gap: 0.375rem !important;
		font-variant: small-caps !important;
		font-feature-settings: "c2sc", "smcp" !important;
		font-size: 0.82rem !important;
		font-weight: 700 !important;
		color: ${theme.color.black} !important;
		font-family: ${theme.font.secondary} !important;
		text-align: left !important;
		text-transform: lowercase !important;
		
		.status-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			width: 14px;
			height: 14px;
		}
		
		& > span:last-child {
			flex: 1;
			min-width: 0;
			font-variant: small-caps !important;
			font-feature-settings: "c2sc", "smcp" !important;
			font-size: 0.82rem !important;
			font-weight: 700 !important;
			color: ${theme.color.black} !important;
			font-family: ${theme.font.secondary} !important;
			text-align: left;
			line-height: 1.2 !important;
			word-wrap: break-word;
			overflow-wrap: break-word;
			hyphens: auto;
			text-transform: lowercase !important;
			/* Allow text to wrap instead of overflow */
			white-space: normal !important;
			overflow: visible !important;
			text-overflow: unset !important;
		}
	}

	& .icon {
		width: 3.6rem;
		height: 3.6rem;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 50%;
		left: 0;
		transform: translateY(-50%);
		background-color: ${(props) => (props.color ? props.color : "#33AF89")};
		border-radius: 100rem;
		box-shadow: 
			0 4px 12px ${(props) => (props.color ? props.color + "30" : "rgba(51, 175, 137, 0.2)")},
			0 2px 8px rgba(0, 0, 0, 0.15);
		z-index: 10;

		& > span {
			height: auto;
			width: min-content;
			color: #ffffff;
			text-transform: uppercase;
			font-family: ${theme.font.secondary};
			font-size: 1.3rem;
			font-weight: 500;
			display: block;
			line-height: 1;
		}
	}
`;
